var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#0AFFF0",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 19.1673H9.99992C6.37992 19.1673 4.83325 17.6207 4.83325 14.0007V10.0007C4.83325 6.38065 6.37992 4.83398 9.99992 4.83398H13.9999C17.6199 4.83398 19.1666 6.38065 19.1666 10.0007V14.0007C19.1666 17.6207 17.6199 19.1673 13.9999 19.1673ZM9.99992 5.83398C6.92658 5.83398 5.83325 6.92732 5.83325 10.0007V14.0007C5.83325 17.074 6.92658 18.1673 9.99992 18.1673H13.9999C17.0733 18.1673 18.1666 17.074 18.1666 14.0007V10.0007C18.1666 6.92732 17.0733 5.83398 13.9999 5.83398H9.99992Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.375C7.74 13.375 7.125 12.76 7.125 12C7.125 11.24 7.74 10.625 8.5 10.625C9.26 10.625 9.875 11.24 9.875 12C9.875 12.76 9.26 13.375 8.5 13.375ZM8.5 11.375C8.155 11.375 7.875 11.655 7.875 12C7.875 12.345 8.155 12.625 8.5 12.625C8.845 12.625 9.125 12.345 9.125 12C9.125 11.655 8.845 11.375 8.5 11.375Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.375C14.74 13.375 14.125 12.76 14.125 12C14.125 11.24 14.74 10.625 15.5 10.625C16.26 10.625 16.875 11.24 16.875 12C16.875 12.76 16.26 13.375 15.5 13.375ZM15.5 11.375C15.155 11.375 14.875 11.655 14.875 12C14.875 12.345 15.155 12.625 15.5 12.625C15.845 12.625 16.125 12.345 16.125 12C16.125 11.655 15.845 11.375 15.5 11.375Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.375C11.24 13.375 10.625 12.76 10.625 12C10.625 11.24 11.24 10.625 12 10.625C12.76 10.625 13.375 11.24 13.375 12C13.375 12.76 12.76 13.375 12 13.375ZM12 11.375C11.655 11.375 11.375 11.655 11.375 12C11.375 12.345 11.655 12.625 12 12.625C12.345 12.625 12.625 12.345 12.625 12C12.625 11.655 12.345 11.375 12 11.375Z",
    fill: "#27313D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.dbbbf8452fb7e27ed447ed6d85ac4007.svg";
export { ForwardRef as ReactComponent };